import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { deactivateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getDeactivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const DeactivateBatch = () => (
  <BatchDetail
    title="Deactivate"
    apiGet={__getDeactivate}
    client={CLIENTS.pwg}
    columnsFactory={(ctx) => deactivateColumns({ ...ctx, iccidHeaderName: "ESN" })}
    copyKeys={COPY_KEYS}
    exportAction="deactivate"
    retryOperation="deactivate"
    showTerminate
    getRowPath={(row) => `/pwg/deactivate/${row.id}`}
  />
);

export default DeactivateBatch;
